export enum SessionsDisplayType {
    SHOW_ALL = "showAll",
    UPCOMING_ONLY = "upcomingOnly",
    TOGGLE = "toggle",
}
